import { makeApiCall } from "../apiRequest";

export default {
  actions: {
    async signUpPassKey({ commit }, payload) {
      const response = await makeApiCall(
        `User/LoginWithPassKey?PassKey=${payload}`,
        "POST"
      );
      return response;
    },
    async continueWithEmail({ commit }, payload) {
      const response = await makeApiCall(
        `User/ContinueWithEmail`,
        "POST",
        payload
      );
      return response;
    },
    async signupWithEmail({ commit }, payload) {
      const response = await makeApiCall(
        `User/Signup`,
        "POST",
        payload
      );
      return response;
    },
    async verifyEmailOtp({ commit }, payload) {
      const response = await makeApiCall(
        `User/VerifyOTP`,
        "POST",
        payload
      );
      return response;
    },
    async loginWithPassword({ commit }, payload) {
      const response = await makeApiCall(
        `User/LoginWithPassword`,
        "POST",
        payload
      );
      return response;
    },
    async forgotPassword({ commit }, payload) {
      const response = await makeApiCall(
        `User/ForgotPassword`,
        "POST",
        payload
      );
      return response;
    },
    async sendOTP({ commit }, payload) {
      const response = await makeApiCall(
        `User/SendOTP?emailAddress=${encodeURIComponent(payload.email)}`,
        "POST"
      );
      return response;
    },
    async verifyForgotPasswordOTP({ commit }, payload) {
      const response = await makeApiCall(
        `User/ForgetPasswordVerifyOTP`,
        "POST",
        payload
      );
      return response;
    },
    async resetPassword({ commit }, payload) {
      const response = await makeApiCall(
        `User/ResetPassword`,
        "POST",
        payload
      );
      return response;
    },
  },
};
